// extracted by mini-css-extract-plugin
export default {"addNewTokenModal":"AddNewToken_addNewTokenModal__yVlwr"};